import * as fromProducts from './products.reducer';
import * as fromCollections from './collections.reducer';
import * as fromCarts from './carts.reducer';
import * as fromPages from './pages.reducer';
import * as fromMenu from './menu.reducer';
import * as fromCustomer from './customer.reducer';
import * as fromOrders from './orders.reducer';
import * as fromAddresses from './addresses.reducer';
import * as fromShop from './shop.reducer';
import * as fromSearch from './search.reducer';
import * as fromExemptions from './tax-exemptions.reducer';
import * as fromKlaviyo from './klaviyo.reducer';
import { ActionReducerMap, createFeatureSelector, MetaReducer } from '@ngrx/store';
import { environment } from '../../../../environments/environment';

export const featureKey = 'shopify';

export interface ShopifyState {
  products: fromProducts.ProductsState;
  collections: fromCollections.CollectionsState;
  carts: fromCarts.CartsState;
  pages: fromPages.PagesState;
  menus: fromMenu.MenusState;
  customer: fromCustomer.CustomerState;
  orders: fromOrders.OrdersState;
  addresses: fromAddresses.AddressesState;
  shop: fromShop.ShopState;
  search: fromSearch.SearchState;
  exemptions: fromExemptions.TaxExemptionsState;
  klaviyo: fromKlaviyo.KlaviyoState;
}

export const reducers: ActionReducerMap<ShopifyState> = {
  products: fromProducts.ProductReducer,
  collections: fromCollections.CollectionReducer,
  carts: fromCarts.CartsReducer,
  pages: fromPages.PagesReducer,
  menus: fromMenu.MenuReducer,
  customer: fromCustomer.customerReducer,
  orders: fromOrders.ordersReducer,
  addresses: fromAddresses.addressesReducer,
  shop: fromShop.ShopReducer,
  search: fromSearch.SearchReducer,
  exemptions: fromExemptions.taxExemptionsReducer,
  klaviyo: fromKlaviyo.klaviyoReducer,
};

export const getShopifyState = createFeatureSelector<ShopifyState>(featureKey);

export const metaReducers: MetaReducer<ShopifyState>[] = !environment.production ? [] : [];
